"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Contract = void 0;
const ethers_1 = require("ethers");
const abi_1 = require("../../abi/abi");
const address_1 = require("../../utils/address");
class ERC20Contract {
    contract;
    constructor(address, provider) {
        if (!(0, address_1.validateContractAddress)(address)) {
            throw new Error('Invalid ERC20 address for contract');
        }
        this.contract = new ethers_1.Contract(address, abi_1.abi.token.erc20, provider);
    }
    createSpenderApproval(spender, amount) {
        return this.contract.approve.populateTransaction(spender, amount);
    }
    createTransfer(toAddress, amount) {
        return this.contract.transfer.populateTransaction(toAddress, amount);
    }
    balanceOf(account) {
        return this.contract.balanceOf(account);
    }
}
exports.ERC20Contract = ERC20Contract;
